<template>
  <div>
    <v-layout>
      <page-title class="ml-4">Templates</page-title>
    </v-layout>
    <v-layout>
      <page-subtitle>
        Run applications and AI models in the cloud, on-prem servers or data center of your choice.
      </page-subtitle>
    </v-layout>

    <v-layout d-flex justify-center>
      <v-text-field
          style="max-width: 600px"
          class="mt-4 mb-4"          
          v-model="filter"
          :disabled="!fuse"
          append-icon="mdi-magnify"
          label="Search templates"
          single-line
          hide-details
          outlined
          dense
        ></v-text-field>
    </v-layout>

    <v-layout d-flex justify-center>
      <!-- all -->
      <v-chip-group>
        <v-chip
          outlined       
          @click="categoryFilter = ''"
        >
          All
        </v-chip>
      </v-chip-group>      
      <v-chip-group v-model="categoryFilter">
        <v-chip
          outlined
          :class="categoryFilter === category ? 'primary' : ''"
          v-for="category in categories"
          :key="category"
          :value="category"
          @click="categoryFilter = category"
        >
          {{ category }}
        </v-chip>
      </v-chip-group>
    </v-layout>

    <v-container fluid>
      <v-row dense>
        <v-col v-for="template in filtered" :key="template.id" cols="3">
          <GalleryTemplateLaunch 
            :template="template"
            :open="$route.query.id === template.id"
          />
        </v-col>
      </v-row>      
    </v-container>

  </div>
</template>

<script>
import PageSubtitle from '../PageSubtitle';
import PageTitle from '../PageTitle';
import GalleryTemplateLaunch from './GalleryTemplateLaunch.vue';
import Fuse from 'fuse.js';

export default {
  components: {
    PageSubtitle,
    PageTitle,
    GalleryTemplateLaunch
  },
  data() {
    return {
      filter: '',
      categoryFilter: '',
      fuse: null
    }
  },

  computed: {
    loading() {
      return this.$store.state.application.templatesLoading;
    },
    categories() {
      if (!this.templates) {
        return [];
      }
      // A map of categories
      let categories = {};
      // Each template has one or more categories
      this.templates.forEach(template => {
        if (!template.categories || template.categories.length === 0) {
          return;
        }
        template.categories.forEach(category => {
          if (!categories[category]) {
            categories[category] = 0;
          }
          categories[category]++;
        });
      });
      // Convert to an array []string
      return Object.keys(categories);
    },
    filtered() {      
      if (this.filter === '' && this.categoryFilter === '') {
        return this.templates;
      }
      // let result = this.fuse.search(this.categoryFilter + ' ' + this.filter)
      let result = this.fuse.search(`=${this.categoryFilter} ${this.filter}`)
      // Filter results that have good score
      result = result.filter(r => r.score < 0.5)

      return result.map(r => {
        return r.item
      })
    },
    templates() {
      return this.$store.state.application.templates;
    }
  },

  mounted() {
    // Subscribe to close-template event
    this.$root.$on('close-template', () => {
      console.log('close-template event received');
      this.$router.push({ query: {} });
    });

    this.$store.dispatch('ListApplicationTemplates',).then(() => {
      // Create a new instance of Fuse
      const options = {
        includeScore: true,
        keys: [
          {
            name: 'id',
            weight: 2
          },
          {
            name: 'name',
            weight: 2
          },
          {
            name: 'categories',
            // weight: 1
          },
          {
            name: 'description',
            weight: 1
          }
        ]
      }

      this.fuse = new Fuse(this.templates, options)
    });
  }
}

</script>